import { Outlet, Link } from "react-router-dom";
import Header from "../../components/Header/Header";

export default function LandingLayout() {
  return (
    <div>
      Header
      <main>
        <Outlet />
      </main>
    </div>
  );
}
